export default __webpack_public_path__ + "static/media/basket-white.22b68878.svg";